import React from 'react';

const NOMINATE_EMAIL = 'courage@drishtikonhimmatwaalimission.in';

const HomeNominate = () => {
  return (
    <section className="bg-white px-6 py-14 md:px-12">
      <div className="mx-auto max-w-5xl space-y-10">
        <div className="text-center">
          <h2 className="mb-5 text-3xl font-bold uppercase text-accent md:text-4xl">
            Nominate a Himmatwaali
          </h2>
          <p className="text-base leading-relaxed text-gray-700 md:text-lg">
           Dear Friends, if you come across a lower strata woman, from any part of India, 
           who fits in our concept of HIMMATWAALI and deserves recognition of her courage, 
           please do connect her with us. Since we are operating from Mumbai, in case there is a 
           nomination of a woman who is based out of Mumbai, the award will be courired to her, 
           wherever she is, and delivered in her hands.
          </p>
        </div>

        <div className="flex justify-center overflow-hidden">
          <a
            href={`mailto:${NOMINATE_EMAIL}`}
            className="inline-flex max-w-full items-center gap-2 whitespace-nowrap rounded-full bg-accent px-4 py-3 text-sm font-semibold text-white shadow-md transition-all hover:-translate-y-0.5 hover:bg-accent/90 sm:px-8 sm:text-base"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 shrink-0" viewBox="0 0 20 20" fill="currentColor">
              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
            </svg>
            <span className="overflow-hidden text-ellipsis">{NOMINATE_EMAIL}</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default HomeNominate;
